import { I18n } from "@assets/strings";
import React, { useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import styled from "styled-components";
import {
	allCountrycodes,
	Country,
	CountryCode,
	countryCodes,
	countries as defaultCountries,
} from "@domain/currentProfile/countryCode";
import { CloseButton } from "@ui/modals/closeButton";
import { DeleteIcon } from "@ui/components/icons";
import { CountryDatalist } from "@ui/components/inputs/countryDatalist";
import { Bloc, Row } from "@ui/components/layout";

interface CountriesFilterProps extends React.HTMLAttributes<HTMLDivElement> {
	exportSelectedCountries: (countries: CountryCode[] | undefined) => void;
	initialCountries: CountryCode[] | undefined;
}

export const CountriesFilter: React.FC<CountriesFilterProps> = ({ exportSelectedCountries, initialCountries }) => {
	const initialCountriesNames: Country[] = initialCountries
		? initialCountries.map((cntry) => cntry && defaultCountries[cntry])
		: [];
	const [countries, setCountries] = useState<Country[]>(initialCountriesNames || []);
	const [country, setCountry] = useState<Country | undefined>(undefined);

	useEffect(() => {
		if (countries.length === 0) exportSelectedCountries(undefined);
		else {
			const newCountryCodes = countries.map((country) => countryCodes[country]);
			exportSelectedCountries(newCountryCodes);
		}
	}, [countries]);

	useEffect(() => {
		if (!initialCountries) setCountries([]);
	}, [initialCountries]);

	return (
		<>
			<CountryDatalist
				id="countries"
				value={country}
				onChange={(v: Country) => {
					setCountry(v);
					if (Object.values(defaultCountries).includes(v) && !countries.includes(v)) {
						setCountries([...countries, v]);
						setCountry(undefined);
					}
				}}
				placeholder={I18n.t("onboarding.country.placeholder")}
				options={allCountrycodes.filter((c) => !countries.includes(defaultCountries[c]))}
			/>
			{countries.map((c: Country, index: number) => (
				<Row key={index}>
					<StyledCloseButton
						onClick={() => {
							const newCountries: Country[] = [];
							countries.forEach((cntry) => {
								if (cntry !== c) newCountries.push(cntry);
							});
							setCountries(newCountries);
						}}
					>
						<DeleteIcon />
					</StyledCloseButton>

					<StyledFlagBloc>
						<ReactCountryFlag
							className="emojiFlag"
							countryCode={countryCodes[c]}
							style={{
								fontSize: 20,
							}}
							aria-label={c}
						/>
					</StyledFlagBloc>
					<StyledCountryNameBloc>
						<span style={{ marginLeft: 14 }}>{c}</span>
					</StyledCountryNameBloc>
				</Row>
			))}
		</>
	);
};

const StyledCloseButton = styled(CloseButton)`
	position: unset;
	top: unset;
	right: unset;
	margin-top: 10px;
	margin-right: 10px !important;
`;

const StyledFlagBloc = styled(Bloc)``;

const StyledCountryNameBloc = styled(Bloc)`
	width: -moz-available;
	margin-top: 14px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
